import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import EvaluationQuestionSectionAPI from './api'

export default class EvaluationQuestionSection extends Model {
  static api = EvaluationQuestionSectionAPI.create(EvaluationQuestionSection)
  static readOnlyFields = ['id', 'title', 'helpText', 'order']

  constructor({ id = null, title = '', helpText = '', order = null } = {}) {
    super()
    Object.assign(this, {
      id,
      title,
      helpText,
      order,
    })
  }

  static create(opts = {}) {
    return new EvaluationQuestionSection(opts)
  }

  static fromAPI(json = {}) {
    const camelJson = snakeToCamel(json)
    return new EvaluationQuestionSection(camelJson)
  }

  copy() {
    return new EvaluationQuestionSection(this)
  }
}
